import request from "@/axios";

/** 分页获取应用跳转配置列表 */
export const getAppJumpList = (params) => {
  return request({
    url: "/lebo-addition/web/jumpConfig/page",
    method: "get",
    params
  });
};

/** 新增应用跳转配置 */
export const addAppJump = (data) => {
  return request({
    url: "/lebo-addition/web/jumpConfig/save",
    method: "post",
    data
  });
};

/** 更新应用跳转配置 */
export const updateAppJump = (data) => {
  return request({
    url: "/lebo-addition/web/jumpConfig/update",
    method: "post",
    data
  });
};

/** 删除应用跳转配置（支持批量删除） */
export const deleteAppJump = (ids) => {
  return request({
    url: "/lebo-addition/web/jumpConfig/delete",
    method: "post",
    params: {
      ids: Array.isArray(ids) ? ids.join(',') : ids
    }
  });
};

/** 获取应用跳转配置详情 */
export const getAppJumpDetail = (id) => {
  return request({
    url: `/lebo-addition/web/jumpConfig/detail/${id}`,
    method: "get"
  });
};

/** 获取操作日志列表 */
export const getAppJumpLogList = (params) => {
  return request({
    url: `/lebo-addition/web/operationLog/page`,
    method: "get",
    params: {
      module: 1, // 1: 应用跳转管理
      subjectId: params.subjectId,
      ...params
    }
  });
}; 